import React from 'react';
import { Helmet } from 'react-helmet';

const ReviewsSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Energy Performance Direct",
    "image": "https://customer-assets.emergentagent.com/job_energy-direct-revamp/artifacts/qrurduho_Big%20Logo.jpg",
    "@id": "https://energyperformancedirect.co.uk",
    "url": "https://energyperformancedirect.co.uk",
    "telephone": "01392980077",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Exeter",
      "addressLocality": "Exeter",
      "addressRegion": "Devon",
      "postalCode": "EX1",
      "addressCountry": "GB"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 50.7184,
      "longitude": -3.5339
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday"
      ],
      "opens": "09:00",
      "closes": "17:00"
    },
    "priceRange": "£120 - £1500",
    "areaServed": [
      {
        "@type": "GeoCircle",
        "geoMidpoint": {
          "@type": "GeoCoordinates",
          "latitude": 50.7184,
          "longitude": -3.5339
        },
        "geoRadius": "50000"
      },
      {
        "@type": "AdministrativeArea",
        "name": "South West England"
      }
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "200",
      "bestRating": "5",
      "worstRating": "1"
    },
    "review": [
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "Sarah Mitchell"
        },
        "datePublished": "2025-01-15",
        "reviewBody": "Excellent service from start to finish. The assessor was punctual, professional, and explained everything clearly. Certificate delivered within 24 hours. Highly recommend for anyone needing an EPC in Exeter.",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        }
      },
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "John Davies"
        },
        "datePublished": "2025-01-10",
        "reviewBody": "Used Energy Performance Direct for our office building EPC. The service was efficient, the report was comprehensive, and the advice on improvements was practical and cost-effective.",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        }
      },
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "Emma Thompson"
        },
        "datePublished": "2025-01-05",
        "reviewBody": "As a landlord with multiple properties, the MEES compliance advice was invaluable. They helped me understand exactly what improvements were needed and prioritized them by cost-effectiveness.",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        }
      },
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "David Wilson"
        },
        "datePublished": "2024-12-28",
        "reviewBody": "Nationwide digital service was perfect for our new build project. Fast turnaround, accurate calculations, and excellent communication throughout.",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        }
      }
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default ReviewsSchema;
